export default "__VITE_ASSET__CyH5GQKL__"